<template>
    <div class="text-center">
        <h3 class="mt-2 colorPulsing">Wird an die Kasse übermittelt...</h3>
        <div class="mt-2 mb-4" style="opacity: 0.8">Diese Seite aktualisiert automatisch</div>
    </div>
</template>

<script>
    export default {
        name: "WaitingForPos"
    }
</script>

<style scoped lang="scss">

</style>